import { baseService } from "service/base";

class AlertV3Service {
  load() {
    return baseService.get("/api/alerts/v3");
  }

  // eslint-disable-next-line max-params
  new(name, eventNames, targets, users, params) {
    return baseService.post("/api/alert/v3", {
      event_names: eventNames,
      name: name,
      params: params,
      targets: targets,
      users: users,
    });
  }

  // eslint-disable-next-line max-params
  edit(alertId, name, eventNames, targets, users, params) {
    return baseService.put(`/api/alert/v3/${alertId}`, {
      name,
      params,
      targets,
      users,
      event_names: eventNames,
    });
  }

  delete(alertId) {
    return baseService.delete(`/api/alert/v3/${alertId}`);
  }
}

const alertV3Service = new AlertV3Service();
export { alertV3Service };
